var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3525 3.20725C16.2847 2.27501 17.8259 2.25136 18.7463 3.21373L20.7863 5.25376C21.7487 6.17413 21.725 7.71535 20.7928 8.64758L8.57763 20.8628C8.45615 20.9842 8.29666 21.0603 8.12581 21.0783L4.23392 21.488C3.23988 21.6129 2.38721 20.7602 2.51207 19.7662L2.92175 15.8742C2.93973 15.7034 3.01582 15.5439 3.1373 15.4224L15.3525 3.20725ZM17.665 4.25339C17.3527 3.92371 16.7785 3.90252 16.4131 4.26791L15.0274 5.65369L18.3464 8.9727L19.7321 7.58692C20.0975 7.22153 20.0763 6.64734 19.7467 6.33502L19.7321 6.32088L17.6792 4.26791L17.665 4.25339ZM17.2857 10.0334L13.9667 6.71435L4.38571 16.2953L4.00291 19.9319L4.00045 19.9525C3.99953 19.9595 4.00032 19.9635 4.00167 19.9674C4.00346 19.9724 4.0073 19.9793 4.01404 19.986C4.02079 19.9928 4.02768 19.9966 4.03269 19.9984C4.03651 19.9997 4.04058 20.0005 4.04753 19.9996L4.06814 19.9971L7.70472 19.6143L17.2857 10.0334Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/EditPen.0e51f1173c73f31a6fd9742383a0faba.svg";
export { ForwardRef as ReactComponent };